import React from 'react';

import {Icon} from '@albert-io/atomic';

/**
 * Decoration layered over the host IconButton's `arrows-rotate` glyph — a check badge (synced), warning
 * badge (error), or slash (can't sync) — composed in code since a single-color FA-kit glyph can't do the
 * Figma's 2-color badges. Pointer-events off so the IconButton stays the click target.
 */
export const SyncStatusOverlay = ({status}: {status: 'synced' | 'error' | 'blocked'}) => {
  if (status === 'blocked') {
    // Tertiary so the slash matches the muted (can't-sync) base arrows.
    return (
      <span className='pointer-events-none absolute inset-[0] flex items-center justify-center'>
        <Icon icon='slash' iconStyle='regular' color='tertiary' />
      </span>
    );
  }
  const isSynced = status === 'synced';
  // Synced badge sits bottom-right, error badge top-left (per Figma).
  const corner = isSynced ? 'bottom-[-3px] right-[-3px]' : 'top-[-3px] left-[-3px]';
  return (
    <span className='pointer-events-none absolute inset-[0] flex items-center justify-center'>
      <span className='relative h-[1em] w-[1em]'>
        <span className={`absolute inline-flex rounded-full background-primary p-[1px] ${corner}`}>
          <Icon
            icon={isSynced ? 'circle-check' : 'circle-exclamation'}
            iconStyle='solid'
            color={isSynced ? 'positive' : 'warning'}
            className='fa-2xs'
          />
        </span>
      </span>
    </span>
  );
};
